
import logo from "../../images/logo_service_texto.png";
import "./header.scss";

const Header = () => {
  return (
    <header className="App-header">
      <div className="menu-header">
        
          <img src={logo} alt="Logo" id="logo" />

      </div>
      
    </header>
  );
};

export default Header;
